var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16101",
    "data-name": "Rectangle 16101",
    width: 15.821,
    height: 15.838,
    fill: "#f54e30"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15645",
    "data-name": "Group 15645",
    transform: "translate(-621 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8998",
    "data-name": "Group 8998",
    transform: "translate(621.319 241)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.319)",
    fill: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15467",
    "data-name": "Group 15467",
    transform: "translate(637.166 245.647) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15411",
    "data-name": "Group 15411",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41212",
    "data-name": "Path 41212",
    d: "M11.98,9.6H9.768c-.174,0-.174,0-.175.179,0,1.442,0,2.884,0,4.326a1.625,1.625,0,0,1-1.014,1.587A1.682,1.682,0,0,1,6.3,14.662a2.062,2.062,0,0,1-.077-.59c-.006-1.438,0-2.877,0-4.315,0-.156,0-.155-.156-.155-1.467,0-2.934,0-4.4,0a1.687,1.687,0,0,1-.6-3.256,1.866,1.866,0,0,1,.627-.111c1.467-.009,2.934,0,4.4,0,.129,0,.132,0,.132-.147q0-2.179,0-4.359A1.653,1.653,0,0,1,6.764.441a1.687,1.687,0,0,1,2.769.8,1.936,1.936,0,0,1,.058.484c0,1.449,0,2.9,0,4.348,0,.153,0,.154.159.154,1.427,0,2.854,0,4.282,0a1.738,1.738,0,0,1,1.149.36A1.614,1.614,0,0,1,15.8,8.151a1.6,1.6,0,0,1-1.265,1.4,1.759,1.759,0,0,1-.442.046c-.7,0-1.409,0-2.114,0",
    transform: "translate(0 0)",
    fill: "#f54e30"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7dff92cdaa928e874334d8b80db13f64.svg";
export { ForwardRef as ReactComponent };